<template>
  <div class="bottom-safe">
    <van-nav-bar
      :title="title"
      left-text=""
      right-text=""
    />
    <div class="inner-container">
      <van-cell
        v-for="item in items"
        :key="item.id"
      >
        <show-image 
          :img-id="item.cover"
          :radius="4"
        />
        <!-- <h2>{{item.title}}</h2> -->
        <div class="desc van-multi-ellipsis--l2">
          {{item.description}}
        </div>
      </van-cell>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue'
  import { NavBar } from 'vant'
  import { Image } from 'vant'
  import { Cell } from 'vant'
  import ShowImage from './show-image.vue'
  Vue.use(NavBar)
  Vue.use(Image)
  Vue.use(Cell)
  export default {
    name: "TopicsAll",
    components: {
      ShowImage
    },
    data () {
      return {
        slug: this.$route.params.slug, // show 的 slug
        title: '专题',
        items: []
      }
    },
    methods: {
      getData: function () {
        this.$api.topic.list().then(res => {
          window.console.log("已获取 Topics 数据", res)
          this.items = res.data.results
          this.title = `${this.title} (${res.data.count})`
        })
      },
    },
    mounted () {
      this.getData()
    }
  }
</script>

<style lang="css" scoped>
.desc {
  color: #666;
  line-height: 125%;
  margin-top: 10px;
}
</style>
